import { grey } from "@mui/material/colors";

const styles = {
  tableContainer: {
    borderRadius: 2,
    border: "1px solid",
    maxHeight: { xs: "auto", md: "calc(100vh - 400px)" },
    borderColor: grey[200],
  },
  table: {
    maxWidth: { xs: "100%", md: "auto" },
    minWidth: { xs: "100%", md: 650 },
  },
  backdrop: {
    color: "#fff",
    zIndex: 9999,
    position: "absolute",
    borderRadius: 2,
  },
  statCard: {
    height: "100%",
  },
  statValue: {
    fontWeight: 700,
    mt: 1,
  },
  statLabel: {
    color: grey[700],
  },
  statHint: {
    color: grey[600],
    mt: 1,
  },
  statusChip: {
    textTransform: "capitalize" as const,
  },
  currencyLine: {
    fontWeight: 700,
    mt: 0.5,
    lineHeight: 1.2,
  },
  currencyCode: {
    color: grey[600],
    fontWeight: 500,
    ml: 0.5,
  },
  threadDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
  },
  threadDialogContent: {
    minHeight: "60vh",
  },
  threadLoadingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh",
  },
};

export default styles;
